/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Comparison_Nopricefound2Inputs */

const id_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada harga ditemukan`)
};

const ms_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada harga ditemui`)
};

const da_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen pris fundet`)
};

const de_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Preis gefunden`)
};

const en_us2_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No price found`)
};

const es_es2_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró precio`)
};

const es_mx2_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontró precio`)
};

const fil_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang presyo`)
};

const fr_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun prix trouvé`)
};

const it_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun prezzo trovato`)
};

const hu_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található ár`)
};

const nl_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen prijs gevonden`)
};

const no_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen pris funnet`)
};

const pl_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono ceny`)
};

const pt_br2_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No price found`)
};

const pt_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum preço encontrado`)
};

const ro_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-a găsit preț`)
};

const fi_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hintaa ei löytynyt`)
};

const sv_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inget pris hittades`)
};

const vi_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy giá`)
};

const tr_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiyat bulunamadı`)
};

const cs_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenalezena žádná cena`)
};

const bg_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерена цена`)
};

const ru_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цена не найдена`)
};

const uk_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ціну не знайдено`)
};

const ar_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على سعر`)
};

const hi_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई कीमत नहीं मिली`)
};

const th_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบราคา`)
};

const ja_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格が見つかりません`)
};

const zh_cn2_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No price found`)
};

const zh_hant1_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No price found`)
};

const ko_components_comparison_nopricefound2 = /** @type {(inputs: Components_Comparison_Nopricefound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No price found`)
};

/**
* | output |
* | --- |
* | "No price found" |
*
* @param {Components_Comparison_Nopricefound2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_comparison_nopricefound2 = /** @type {((inputs?: Components_Comparison_Nopricefound2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Comparison_Nopricefound2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_comparison_nopricefound2(inputs)
	if (locale === "ms") return ms_components_comparison_nopricefound2(inputs)
	if (locale === "da") return da_components_comparison_nopricefound2(inputs)
	if (locale === "de") return de_components_comparison_nopricefound2(inputs)
	if (locale === "en-US") return en_us2_components_comparison_nopricefound2(inputs)
	if (locale === "es-ES") return es_es2_components_comparison_nopricefound2(inputs)
	if (locale === "es-MX") return es_mx2_components_comparison_nopricefound2(inputs)
	if (locale === "fil") return fil_components_comparison_nopricefound2(inputs)
	if (locale === "fr") return fr_components_comparison_nopricefound2(inputs)
	if (locale === "it") return it_components_comparison_nopricefound2(inputs)
	if (locale === "hu") return hu_components_comparison_nopricefound2(inputs)
	if (locale === "nl") return nl_components_comparison_nopricefound2(inputs)
	if (locale === "no") return no_components_comparison_nopricefound2(inputs)
	if (locale === "pl") return pl_components_comparison_nopricefound2(inputs)
	if (locale === "pt-BR") return pt_br2_components_comparison_nopricefound2(inputs)
	if (locale === "pt") return pt_components_comparison_nopricefound2(inputs)
	if (locale === "ro") return ro_components_comparison_nopricefound2(inputs)
	if (locale === "fi") return fi_components_comparison_nopricefound2(inputs)
	if (locale === "sv") return sv_components_comparison_nopricefound2(inputs)
	if (locale === "vi") return vi_components_comparison_nopricefound2(inputs)
	if (locale === "tr") return tr_components_comparison_nopricefound2(inputs)
	if (locale === "cs") return cs_components_comparison_nopricefound2(inputs)
	if (locale === "bg") return bg_components_comparison_nopricefound2(inputs)
	if (locale === "ru") return ru_components_comparison_nopricefound2(inputs)
	if (locale === "uk") return uk_components_comparison_nopricefound2(inputs)
	if (locale === "ar") return ar_components_comparison_nopricefound2(inputs)
	if (locale === "hi") return hi_components_comparison_nopricefound2(inputs)
	if (locale === "th") return th_components_comparison_nopricefound2(inputs)
	if (locale === "ja") return ja_components_comparison_nopricefound2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_comparison_nopricefound2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_comparison_nopricefound2(inputs)
	return ko_components_comparison_nopricefound2(inputs)
});
export { components_comparison_nopricefound2 as "components.comparison.noPriceFound" }